/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function, no-empty-function, max-lines */
import { useCallback, useMemo, useReducer } from "react";
import reducer, { DEFAULT_NEWS, initialState, RESET_SELECTED_NEWS_CRITICS, RESET_SELECTED_NEWS_CRITICS_LIST, SET_ADDITIONAL_INSTRUCTIONS, SET_AUTHOR_ID, SET_HOME_VIDEO_ID, SET_IMAGES, SET_IMDB_ID, SET_IS_ADD_HOME_VIDEO, SET_IS_ONLY_NEW, SET_IS_ONLY_PRESENT, SET_IS_SHOW_FLAGGED, SET_IS_TOGGLE_FLAGGED_LOADING, SET_IS_UHD, SET_LIST, SET_NAME, SET_NEXT_CURSOR, SET_OVERRIDES, SET_RELEASE_DATE, SET_SCREENSHOTS, SET_SELECTED_ID, SET_SELECTED_IS_NEWS_CRITICS_CREATED, SET_SELECTED_IS_PREVIEW_LOADING, SET_SELECTED_IS_PREVIEW_VALID, SET_SELECTED_NEWS, SET_SELECTED_SINGLE_SOURCE, SET_TMDB_SELECTED_ID, SET_TMDB_SELECTED_IMDB_ID } from "./reducer";
export { DEFAULT_NEWS };
export const initialContext = {
    clear: () => { },
    clearAll: () => { },
    resetSelectedNewsCritics: () => { },
    setAdditionalInstructions: () => { },
    setAuthorId: () => { },
    setHomeVideoId: () => { },
    setImages: () => { },
    setScreenshots: () => { },
    setIsAddHomeVideo: () => { },
    setIsOnlyNew: () => { },
    setIsOnlyPresent: () => { },
    setIsShowFlagged: () => { },
    setIsToggleFlaggedLoading: () => { },
    setIsUHD: () => { },
    setList: () => { },
    setName: () => { },
    setNextCursor: () => { },
    setIMDbId: () => { },
    setTmdbSelectedImdbId: () => { },
    setTmdbSelectedId: () => { },
    setOverrides: () => { },
    setReleaseDate: () => { },
    setSelectedId: () => { },
    setSelectedIsNewsCriticsCreated: () => { },
    setSelectedIsPreviewLoading: () => { },
    setSelectedIsPreviewValid: () => { },
    setSelectedNewsCritics: () => { },
    setSelectedSingleSource: () => { },
    state: initialState
};
const useNewsCriticsContext = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    /**
     * clear
     *
     * @description Clear the selected news critics for a specific service
     * @param {NewsServiceName} serviceName - The service name to clear
     * @returns {void}
     *
     */
    const clear = useCallback((serviceName) => {
        dispatch({
            payload: { service: serviceName },
            type: RESET_SELECTED_NEWS_CRITICS
        });
    }, [dispatch]);
    /**
     * resetSelectedNewsCritics
     *
     * @description Reset the selected news critics list
     * @param {void}
     * @returns {void}
     *
     */
    const resetSelectedNewsCritics = useCallback(() => {
        dispatch({ type: RESET_SELECTED_NEWS_CRITICS_LIST });
    }, [dispatch]);
    /**
     * setImdbId
     *
     * @description Set the IMDb ID for a specific service
     * @param {string} IMDbId - The IMDb ID to set
     * @returns {void}
     *
     */
    const setIMDbId = useCallback((IMDbId) => {
        dispatch({
            payload: { IMDbId },
            type: SET_IMDB_ID
        });
    }, [dispatch]);
    /**
     * setTmdbSelectedImdbId
     *
     * @description Set the TMDB selected IMDb ID
     * @param {string} tmdbSelectedImdbId - The TMDB selected IMDb ID to set
     * @returns {void}
     *
     */
    const setTmdbSelectedImdbId = useCallback((tmdbSelectedImdbId) => {
        dispatch({
            payload: { tmdbSelectedImdbId },
            type: SET_TMDB_SELECTED_IMDB_ID
        });
    }, [dispatch]);
    /**
     * setTmdbSelectedId
     *
     * @description Set the TMDB selected ID (the TMDB movie/show ID)
     * @param {string} tmdbSelectedId - The TMDB ID to set
     * @returns {void}
     *
     */
    const setTmdbSelectedId = useCallback((tmdbSelectedId) => {
        dispatch({
            payload: { tmdbSelectedId },
            type: SET_TMDB_SELECTED_ID
        });
    }, [dispatch]);
    /**
     * clearAll
     *
     * @description Clear all selected news critics
     * @param {void}
     * @returns {void}
     *
     */
    const clearAll = useCallback(() => {
        resetSelectedNewsCritics();
        setIMDbId("");
        setTmdbSelectedImdbId(undefined);
    }, [resetSelectedNewsCritics, setIMDbId, setTmdbSelectedImdbId]);
    /**
     * setAdditionalInstructions
     *
     * @description Set additional instructions
     * @param {string} additionalInstructions - Additional instructions to set
     * @returns {void}
     *
     */
    const setAdditionalInstructions = useCallback((additionalInstructions) => {
        dispatch({
            payload: { additionalInstructions },
            type: SET_ADDITIONAL_INSTRUCTIONS
        });
    }, [dispatch]);
    /**
     * setAuthorId
     *
     * @description Set the author ID for a specific service
     * @param {number} authorId - The author ID to set
     * @param {NewsServiceName} service - The service to set the author ID for
     * @returns {void}
     *
     */
    const setAuthorId = useCallback((authorId) => {
        dispatch({
            payload: { authorId },
            type: SET_AUTHOR_ID
        });
    }, [dispatch]);
    /**
     * setHomeVideoId
     *
     * @description Set the home video ID for a specific service
     * @param {string | undefined} homeVideoId - The home video ID to set
     * @returns {void}
     *
     */
    const setHomeVideoId = useCallback((homeVideoId) => {
        dispatch({
            payload: { homeVideoId },
            type: SET_HOME_VIDEO_ID
        });
    }, [dispatch]);
    /**
     * setImages
     *
     *  @description Set the image URLs for a specific service
     *  @param {string[]} imageUrls - The image URL to set
     *  @returns {void}
     *
     */
    const setImages = useCallback((images) => {
        dispatch({
            payload: { images },
            type: SET_IMAGES
        });
    }, [dispatch]);
    const setScreenshots = useCallback((screenshots) => {
        dispatch({
            payload: { screenshots },
            type: SET_SCREENSHOTS
        });
    }, [dispatch]);
    /**
     * setIsAddHomeVideo
     *
     * @description Set the isAddHomeVideo flag for a specific service
     * @param {boolean} isAddHomeVideo - The isAddHomeVideo flag to set
     * @returns {void}
     *
     */
    const setIsAddHomeVideo = useCallback((isAddHomeVideo) => {
        dispatch({
            payload: { isAddHomeVideo },
            type: SET_IS_ADD_HOME_VIDEO
        });
    }, [dispatch]);
    /**
     * setIsOnlyNew
     *
     * @description Set the isOnlyNew flag for a specific service
     * @param {boolean} isOnlyNew - The isOnlyNew flag to set
     * @param {NewsServiceName} serviceName - The service name to set
     * @returns {void}
     *
     */
    const setIsOnlyNew = useCallback((isOnlyNew, serviceName) => {
        dispatch({
            payload: { isOnlyNew, service: serviceName },
            type: SET_IS_ONLY_NEW
        });
    }, [dispatch]);
    /**
     * setIsOnlyPresent
     *
     * @description Set the isOnlyPresent flag for a specific service
     * @param {boolean} isOnlyPresent - The isOnlyPresent flag to set
     * @param {NewsServiceName} serviceName - The service name to set
     * @returns {void}
     *
     */
    const setIsOnlyPresent = useCallback((isOnlyPresent, serviceName) => {
        dispatch({
            payload: { isOnlyPresent, service: serviceName },
            type: SET_IS_ONLY_PRESENT
        });
    }, [dispatch]);
    /**
     * setIsShowFlagged
     *
     * @description Set the isShowFlagged flag for a specific service
     * @param {boolean} isShowFlagged - The isShowFlagged flag to set
     * @param {NewsServiceName} serviceName - The service name to set
     * @returns {void}
     *
     */
    const setIsShowFlagged = useCallback((isShowFlagged, serviceName) => {
        dispatch({
            payload: { isShowFlagged, service: serviceName },
            type: SET_IS_SHOW_FLAGGED
        });
    }, [dispatch]);
    /**
     * setIsToggleFlaggedLoading
     *
     * @description Set the toggle flagged loading state
     * @param {boolean} isToggleFlaggedLoading - The loading state to set
     * @returns {void}
     *
     */
    const setIsToggleFlaggedLoading = useCallback((isToggleFlaggedLoading) => {
        dispatch({
            payload: { isToggleFlaggedLoading },
            type: SET_IS_TOGGLE_FLAGGED_LOADING
        });
    }, [dispatch]);
    /**
     * setIsUHD
     *
     * @description Set the isUHD flag
     * @param {boolean} isUHD - The isUHD flag to set
     * @returns {void}
     *
     */
    const setIsUHD = useCallback((isUHD) => {
        dispatch({
            payload: { isUHD },
            type: SET_IS_UHD
        });
    }, [dispatch]);
    const setList = useCallback((list, serviceName) => dispatch({
        payload: { list, service: serviceName },
        type: SET_LIST
    }), [dispatch]);
    const setName = useCallback((name) => {
        dispatch({ payload: { name }, type: SET_NAME });
    }, [dispatch]);
    /**
     * setNextCursor
     *
     * @description Set the next cursor for a specific service
     * @param {string | null} nextCursor - The next cursor to set
     * @param {NewsServiceName} service - The service to set the next cursor for
     * @returns {void}
     *
     */
    const setNextCursor = useCallback((nextCursor, service) => {
        dispatch({
            payload: { nextCursor, service },
            type: SET_NEXT_CURSOR
        });
    }, [dispatch]);
    const setOverrides = useCallback((overrides, serviceName) => {
        dispatch({
            payload: { overrides, serviceName },
            type: SET_OVERRIDES
        });
    }, [dispatch]);
    const setSelectedId = useCallback((selected, serviceName) => {
        dispatch({
            payload: { selected, service: serviceName },
            type: SET_SELECTED_ID
        });
    }, [dispatch]);
    const setSelectedIsNewsCriticsCreated = useCallback((id, serviceName) => {
        dispatch({
            payload: { id, service: serviceName },
            type: SET_SELECTED_IS_NEWS_CRITICS_CREATED
        });
    }, [dispatch]);
    const setSelectedIsPreviewLoading = useCallback((isPreviewLoading, serviceName) => {
        dispatch({
            payload: { isPreviewLoading, service: serviceName },
            type: SET_SELECTED_IS_PREVIEW_LOADING
        });
    }, [dispatch]);
    const setSelectedIsPreviewValid = useCallback((isPreviewValid, serviceName) => {
        dispatch({
            payload: { isPreviewValid, service: serviceName },
            type: SET_SELECTED_IS_PREVIEW_VALID
        });
    }, [dispatch]);
    /**
     * setReleaseDate
     *
     * @description
     * Set release date
     * @param {string} releaseDate - The release date to set
     * @returns {void}
     *
     */
    const setReleaseDate = useCallback((releaseDate) => {
        dispatch({
            payload: { releaseDate },
            type: SET_RELEASE_DATE
        });
    }, [dispatch]);
    /**
     * setSelectedNewsCritics
     *
     * @description
     * Set the selected news critics for a specific service.
     * @param {object} selectedNewsCritics - The selected news critics to set.
     * @returns {void}
     *
     */
    const setSelectedNewsCritics = useCallback(({ id, isPublished, serviceName, title, url }) => {
        dispatch({
            payload: { id, isPublished, service: serviceName, title, url },
            type: SET_SELECTED_NEWS
        });
    }, [dispatch]);
    /**
     * setSelectedSingleSource
     *
     * @description
     * Set the selected single source for a specific service.
     * @param {NewsCriticsContext["setSelectedSingleSource"]} selectedSingleSource - The selected single source to set.
     * @param {string} id - The ID of the selected single source.
     * @param {string} selectedSingleSource.labelId - The label ID of the selected single source.
     * @param {string} selectedSingleSource.outletId - The outlet ID of the selected single source.
     * @param {string} selectedSingleSource.url - The URL of the selected single source.
     * @returns {void}
     *
     */
    const setSelectedSingleSource = useCallback(({ id, labelId, outletId, url }) => {
        dispatch({
            payload: { id, labelId, outletId, url },
            type: SET_SELECTED_SINGLE_SOURCE
        });
    }, [dispatch]);
    return useMemo(() => ({
        clear,
        clearAll,
        resetSelectedNewsCritics,
        setAdditionalInstructions,
        setAuthorId,
        setHomeVideoId,
        setImages,
        setScreenshots,
        setIsAddHomeVideo,
        setIsOnlyNew,
        setIsOnlyPresent,
        setIsShowFlagged,
        setIsToggleFlaggedLoading,
        setIsUHD,
        setList,
        setName,
        setNextCursor,
        setIMDbId,
        setTmdbSelectedImdbId,
        setTmdbSelectedId,
        setOverrides,
        setReleaseDate,
        setSelectedId,
        setSelectedIsNewsCriticsCreated,
        setSelectedIsPreviewLoading,
        setSelectedIsPreviewValid,
        setSelectedNewsCritics,
        setSelectedSingleSource,
        state
    }), [
        clear,
        clearAll,
        resetSelectedNewsCritics,
        setAdditionalInstructions,
        setAuthorId,
        setHomeVideoId,
        setImages,
        setScreenshots,
        setIsAddHomeVideo,
        setIsOnlyNew,
        setIsOnlyPresent,
        setIsShowFlagged,
        setIsToggleFlaggedLoading,
        setIsUHD,
        setList,
        setName,
        setNextCursor,
        setIMDbId,
        setTmdbSelectedImdbId,
        setTmdbSelectedId,
        setOverrides,
        setReleaseDate,
        setSelectedId,
        setSelectedIsNewsCriticsCreated,
        setSelectedIsPreviewLoading,
        setSelectedIsPreviewValid,
        setSelectedNewsCritics,
        setSelectedSingleSource,
        state
    ]);
};
export default useNewsCriticsContext;
